import { OFFICE_CODE } from "../utilities/constants";

export class URLRoutes{

    static OFFICE_CODE = OFFICE_CODE;
    static sPathnameBase = BASE_WEBSITE_URL.replace(/https?:\/\/[\w.:\d\-]*/, '');

    static pathNameBase = () => this.sPathnameBase;

    static baseUrl = () => {
        return `${this.sPathnameBase}/${this.OFFICE_CODE}/`;
    }

    static clientHome = () => {
        return this.baseUrl();
    }

    static clientPage = () => {
        return this.baseUrl() + 'client';
    }

    //search routes
    static searchRezHomePage = () => {
        return this.baseUrl() + 'search'
    }
    static searchRezQr = () => {
        return this.baseUrl() + 'search/qr-search'
    }
    static searchRezNumber = () => {
        return this.baseUrl() + 'search/number-search'
    }
    static searchRezName = () => {
        return this.baseUrl() + 'search/name-search'
    }
    static searchRezResult = () => {
        return this.baseUrl() + 'search/rez-result'
    }

    //quotation routes
    static quotationHome = () => {
        return this.baseUrl() + 'quotation';
    }

    static quotationUpgrade = () => {
        return this.baseUrl() + 'quotation/upgrade';
    }

    static quotationExtras = () => {
        return this.baseUrl() + 'quotation/extras';
    }

    static quotationConfirmation = () => {
        return this.baseUrl() + 'quotation/confirmation';
    }

        //additional drivers
    static additionalDriverForm = () => {
        return this.baseUrl() + 'additional-driver';
    }

    //request signature routes
    static requestSignatureHome = () => {
        return this.baseUrl() + 'signature';
    }

    static requestSignatureAgreement = () => {
        return this.baseUrl() + 'signature/sign-agreement'
    }

    //payments routes
    static paymentCheckIn = () => {
        return this.baseUrl() + 'payments/checkin';
    }
    static paymentRentPayment = () => {
        return this.baseUrl() + 'payments/rent-payment';
    }

    //agreement-pdf routes
    static agreementPdfHome = () => {
        return this.baseUrl() + 'agreement-pdf';
    }

    static agrementPdfSend = () => {
        return this.baseUrl() + 'agreement-pdf/send';
    }

    //opened agreement routes
    static openedAgreementHome = () => {
        return this.baseUrl() + 'opened-agreement';
    }

    static openedAgreementGetYourCar = () => {
        return this.baseUrl() + 'opened-agreement/get-your-car';
    }

    static surveyExperienceHome = () => {
        return this.baseUrl() + 'survey';
    }
}
